module.exports = __webpack_public_path__ + "static/img/marvin-meyer-SYTO3xs06fU-unsplash_thumb.70473df.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/marvin-meyer-SYTO3xs06fU-unsplash_thumb.png
// module id = PjtJ
// module chunks = 4